import logger from './logger';

export const getLocalStorage = (key, defaultValue = null) => {
  try {
    const item = window.localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    logger.warn(`Failed to get localStorage item: ${key}`, error);
    return defaultValue;
  }
};

export const setLocalStorage = (key, value) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    logger.warn(`Failed to set localStorage item: ${key}`, error);
    return false;
  }
};

export const removeLocalStorage = (key) => {
  try {
    window.localStorage.removeItem(key);
    return true;
  } catch (error) {
    logger.warn(`Failed to remove localStorage item: ${key}`, error);
    return false;
  }
};

export const clearLocalStorage = () => {
  try {
    window.localStorage.clear();
    return true;
  } catch (error) {
    logger.warn('Failed to clear localStorage', error);
    return false;
  }
};

export const getSessionStorage = (key, defaultValue = null) => {
  try {
    const item = window.sessionStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    logger.warn(`Failed to get sessionStorage item: ${key}`, error);
    return defaultValue;
  }
};

export const setSessionStorage = (key, value) => {
  try {
    window.sessionStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    logger.warn(`Failed to set sessionStorage item: ${key}`, error);
    return false;
  }
};

export const STORAGE_KEYS = {
  LAST_MODEL: 'forge_last_model',
  FORM_DRAFT: 'forge_form_draft',
  USER_PREFERENCES: 'forge_preferences',
  RECENT_GENERATIONS: 'forge_recent_generations',
  CURRENT_WORKSPACE: 'forge_current_workspace',
};

export const getStoredWorkspaceId = () => {
  return getLocalStorage(STORAGE_KEYS.CURRENT_WORKSPACE, null);
};

export const storeWorkspaceId = (workspaceId) => {
  return setLocalStorage(STORAGE_KEYS.CURRENT_WORKSPACE, workspaceId);
};

export const clearStoredWorkspaceId = () => {
  return removeLocalStorage(STORAGE_KEYS.CURRENT_WORKSPACE);
};

